import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getListTypeOfs = () => {
    return axios.get(`/api/SkKpi/typeOf/list`, { headers: authHeaderJson() } )
};

const getTypeOfById = (typeOfId) => {
        return axios.get(`/api/SkKpi/typeOf/${typeOfId}`, { headers: authHeaderJson() } );
};

const addTypeOf = (typeOf) => {
    return axios.post(`/api/SkKpi/typeOf/add/`, typeOf, { headers: authHeaderJson() } );
}

const addTypeOfList = (typeOfs) => {
    return axios.post(`/api/SkKpi/typeOf/add/list`, typeOfs, { headers: authHeaderJson() } );
}

const saveTypeOfById = (typeOfId, objContract) => {
    return axios.put(`/api/SkKpi/typeOf/${typeOfId}`, objContract, { headers: authHeaderJson() });
};

const deleteTypeOf = (typeOfId) => {
    return axios.delete(`/api/SkKpi/typeOf/${typeOfId}`, { headers: authHeaderJson() });
}

export {
    getListTypeOfs,
    getTypeOfById,
    addTypeOf,
    addTypeOfList,
    saveTypeOfById,
    deleteTypeOf
}